import { render } from "./markup-form.vue?vue&type=template&id=149968e8&scoped=true"
import script from "./markup-form.vue?vue&type=script&lang=js"
export * from "./markup-form.vue?vue&type=script&lang=js"

import "./markup-form.vue?vue&type=style&index=0&id=149968e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149968e8"]])

export default __exports__